import React from 'react';
import './DummyIcon.scss';

export default class DummyIcon extends React.Component {
  render() {
    return <div className="DummyIcon pull-right" />;
  }
}



// WEBPACK FOOTER //
// src/components/DummyIcon.js